import './common-fields.scss';

import React from 'react';

import type { YesNoBoolean, YesNoBooleanFormValue } from '@customTypes/form';

type Props = {
  value: YesNoBooleanFormValue;
  onChange: (val: YesNoBoolean) => void;
  ariaLabel?: string;
  className?: string;
};

export default function YesNoGroup({ value, onChange, ariaLabel, className }: Props) {
  return (
    <div
      className={['btn-group po-yesno-group', className].filter(Boolean).join(' ')}
      role='group'
      aria-label={ariaLabel || 'Yes No'}
    >
      <button
        type='button'
        className={`btn btn-outline-primary ${value === 'YES' ? 'active' : ''}`}
        aria-pressed={value === 'YES'}
        onClick={() => onChange('YES')}
      >
        Yes
      </button>
      <button
        type='button'
        className={`btn btn-outline-primary ${value === 'NO' ? 'active' : ''}`}
        aria-pressed={value === 'NO'}
        onClick={() => onChange('NO')}
      >
        No
      </button>
    </div>
  );
}
